import { TStorage } from '@speedlo/types/src/TStorage'
import localforage from 'localforage'

export const createStorage = (name: string): TStorage => {
  return localforage.createInstance({ name })
}
